import request from '@/utils/request'
// 登录
export function getPost(url, data) {
    return request({
        url: url,
        method: 'post',
        data,
    })
}
export function getSearch(url, data) {
    return request({
        url: url,
        method: 'get',
        params: data
    });
}
export function example(data) {
    return request({
        url: '/mongo/func-eg/',
        method: 'post',
        data
    });
}
export function accessions(data) {
    return request({
        url: '/mongo/get-accessions/',
        method: 'get',
        params: data
    });
}